import { render, staticRenderFns } from "./ModalConfiguracaoUsuario.vue?vue&type=template&id=1f37e0e2&scoped=true&"
import script from "./ModalConfiguracaoUsuario.vue?vue&type=script&lang=js&"
export * from "./ModalConfiguracaoUsuario.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfiguracaoUsuario.vue?vue&type=style&index=0&id=1f37e0e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f37e0e2",
  null
  
)

export default component.exports